module.exports = __webpack_public_path__ + "static/media/social2x.0b6e640a.png";